import { cn } from "@/lib/utils";

/**
 * The Yodi mark, the same tile in every space (contributor header, admin,
 * moderator, accountant and collector sidebars). Solid brand orange, no glow.
 */
export function YodiMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "relative grid size-10 shrink-0 place-items-center rounded-xl bg-primary text-base font-bold text-primary-foreground",
        className,
      )}
    >
      Y
      <span className="absolute bottom-1.5 right-1.5 size-1.5 rounded-full bg-primary-foreground/60" />
    </span>
  );
}
